export const PROJECTS_FETCHING_ERROR_LABEL = "Couldn't load projects at the moment.\nPlease, try refreshing the page.";
